var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-defaultskin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }